import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react"

import type EstimateValues from "../../features/oneClickEstimate/types/params"
import csComEstApi from "./csComEstApi"

const useMinAndStandardLabelQuery = (type: "minLand" | "minPattern", values: EstimateValues) => {
  const fetcher = useCallback(() => csComEstApi.quotationRules(values), [values])

  const { data } = useQuery(
    ["MinAndStandardLabel", values.kibanType, values.layer, values.beatenThickness, values.boardThickness],
    fetcher
  )

  const minId = data?.[type].minThreshold?.id
  const standardId = data?.[type].standard?.id

  return { minId, standardId }
}

export default useMinAndStandardLabelQuery
